import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full flex items-center z-50 truncate text-[12px] font-gordita-regular" }
const _hoisted_2 = { class: "flex flex-nowrap items-center px-[16px] truncate" }
const _hoisted_3 = { class: "truncate" }

import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { computed } from 'vue';
import { Builds_BuildResult } from '@/graphql/codegen/generated/graphql';
import { workloadsResultToDisplayMapping, STATUS_ICON_MAP } from '@/views/workloads/workloads.const';


export default /*#__PURE__*/_defineComponent({
  __name: 'workloadStatus',
  props: {
    status: null
  },
  setup(__props: any) {

const props = __props as { status: Builds_BuildResult }



const iconName = computed(() => STATUS_ICON_MAP[props.status as Builds_BuildResult]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, { class: "w-full h-full flex" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("i", {
            class: _normalizeClass([_unref(iconName), "uis text-[20px] mr-2 flex items-center"])
          }, null, 2),
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(workloadsResultToDisplayMapping)[__props.status]), 1)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})